<div class="loader-container" [class.loading]="loading">
  <div *ngIf="loading" class="spinner-container" [@fadeInOut]>
    <mat-spinner diameter="32"></mat-spinner>
  </div>
  <ng-content></ng-content>
</div>
